<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-title class="title">{{ currentNumber }} / {{ totalNumber }}</v-list-item-title>
            <v-list-item-subtitle>{{ question.field }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
            <v-row align="center">
                <div class="mr-2 d-none d-sm-block">
                    <v-btn @click="increaseFont" icon>
                        <v-icon>mdi-format-font-size-increase</v-icon>
                    </v-btn>
                    <v-btn @click="decreaseFont" icon>
                        <v-icon>mdi-format-font-size-decrease</v-icon>
                    </v-btn>
                </div>

                <normal-value></normal-value>

                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="prevQuestion" icon :disabled="currentNumber === 1">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn @click="nextQuestion" icon :disabled="currentNumber === totalNumber">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>

                <v-btn @click="toggleFlag" icon :class="flagClass">
                    <v-icon>mdi-flag</v-icon>
                </v-btn>
            </v-row>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import NormalValue from './NormalValue'
import { get } from 'vuex-pathify'

export default {
    components: {
        NormalValue
    },

    computed: {
        question: get('tryout/activeQuestion'),

        answer: get('tryout/activeAnswer'),

        currentNumber() {
            return this.$store.get('tryout/activeQuestionIdx') + 1
        },

        totalNumber() {
            return this.$store.get('tryout/questions').length
        },

        flagClass() {
            return this.answer.flagged ? 'error white--text' : ''
        },

        tryoutTrackingTitle() {
            return `${this.$store.get('tryout/title')} ${this.$store.get('enrollment/selected@title')}`
        }
    },

    methods: {
        toggleFlag() {
            const next_flag = ! this.$store.get('tryout/activeAnswer@flagged')
            const history_hash = this.$store.get('tryout/history_hash')
            const idx = this.$store.get('tryout/activeQuestionIdx')

            this.$tracking.event.tryout.flag(
                this.tryoutTrackingTitle,
                idx + 1
            )

            this.$api.put(`work/${history_hash}/${this.question.id}`, {
                flagged: next_flag
            })

            this.$store.set(`tryout/answers@${idx}.flagged`, next_flag)
        },

        increaseFont() {
            this.$tracking.event.tryout.increaseFont(this.tryoutTrackingTitle)
            this.$store.dispatch('tryout/increaseFont')
        },

        decreaseFont() {
            this.$tracking.event.tryout.decreaseFont(this.tryoutTrackingTitle)
            this.$store.dispatch('tryout/decreaseFont')
        },

        prevQuestion() {
            this.$store.dispatch('tryout/prevQuestion')
            this.$tracking.event.tryout.previous(this.tryoutTrackingTitle, this.$store.get('tryout/activeQuestionIdx') + 1)
        },

        nextQuestion() {
            this.$store.dispatch('tryout/nextQuestion')
            this.$tracking.event.tryout.next(this.tryoutTrackingTitle, this.$store.get('tryout/activeQuestionIdx') + 1)
        },
    }
}
</script>
